import { useFormContext } from "react-hook-form";
import { AddressAutoComplete } from "../orders/process/AddressAutoComplete";
import { FormTextFieldElement } from "@rhf-kit/mui";

export const DriverAddressInput = () => {
    const { watch } = useFormContext();
    const driver = watch("driver");

    if (!driver) {
        return null;
    }
    return (
        <>
            <AddressAutoComplete required />
            <FormTextFieldElement
                name={"address2"}
                label={"Address 2"}
                fullWidth
                margin={"normal"}
            />
            <FormTextFieldElement
                name={"city"}
                label={"City"}
                disabled
                margin={"normal"}
                required
                fullWidth
            />
            <FormTextFieldElement
                name={"state"}
                label={"State"}
                disabled
                margin={"normal"}
                required
                fullWidth
            />
            <FormTextFieldElement
                name={"zipCode"}
                disabled
                required
                label={"Zip Code"}
                fullWidth
                margin={"normal"}
                type={"number"}
                rules={{
                    minLength: {
                        value: 5,
                        message: "Please enter a valid 5 digit zip code.",
                    },
                    maxLength: {
                        value: 5,
                        message: "Please enter a valid 5 digit zip code.",
                    },
                }}
            />
        </>
    );
};
